
import { Component, Vue } from 'vue-property-decorator';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';
import { manualAPIActions } from '@/helpers/ManiualAPIHelper';
import { RouteNames } from '@/enums/routes/RouteNames';
import SettingsTopBar from '@/modules/CMS/layout/SettingsTopBar.vue';
import { mixins } from 'vue-class-component';
import { UserRightsMixin } from '@/mixins/UserRights';
import NotAllowedComponent from '@/modules/CMS/layout/NotAllowedComponent.vue';

@Component({
    name: 'ManualAPIRefresh',
    components: { SettingsTopBar, NotAllowedComponent },
})
export default class ManualAPIRefresh extends mixins<UserRightsMixin>(UserRightsMixin) {
    private backRoute: RouteNames = RouteNames.settings;
    private userHasRights: boolean = false;
    private disableButtons: boolean = true;

    private loadingOverlay = new LoadingOverlayHelper(this, {});

    private get actions() {
        return manualAPIActions();
    }

    private created() {
        if (this.isSuperAdmin) {
            this.userHasRights = true;
        }

        this.$store.dispatch('configurator/getColorImportingStatus');
    }

    private get isImportingColor() {
        return this.$store.getters['configurator/isImportingColors'];
    }

    private determineDisabledStatus(type: string | undefined) {
        if (!type) {
            return false;
        }

        switch (type) {
            case 'colorImportStart':
                return this.isImportingColor;
            case 'colorImportStop':
                return !this.isImportingColor;
            default:
                return false;
        }
    }

    private openConfirmUpdateProductFormPopup(action: any) {
        this.$confirm({
            title: action.modalTitle,
            content: '',
            okText: this.$t('Da') as string,
            okType: 'danger',
            cancelText: this.$t('Ne') as string,
            onOk: async () => {
                this.loadingOverlay.start();
                try {
                    await action.action();
                } catch (e) {
                    this.$notification.error({
                        message: this.$t('Dogodila se greška') as string,
                        description: (e as Error).message,
                    });
                    this.loadingOverlay.stop();
                    return;
                }
                this.$notification.success({
                    message: action.successMessage as string,
                    description: '',
                });
                this.loadingOverlay.stop();
            },
        });
    }
}
